<p-card styleClass="p-3 very-compact-card mb-3">
  <p-steps
    [model]="steps"
    [activeIndex]="activeIndexStep"></p-steps>
</p-card>

<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <ng-container *ngIf="!activeIndexStep">
            <div class="field">
              <label class="font-medium required-field">Email</label>
              <crm-input-text
                [(value)]="email.email"
                [isError]="$any(errorEmail?.email)"></crm-input-text>
              <small
                *ngIf="errorEmail?.email"
                class="p-error">
                {{ errorEmail?.email | join }}
              </small>
            </div>
          </ng-container>

          <ng-container *ngIf="activeIndexStep === 1">
            <div class="field">
              <label class="font-medium required-field">ФИО</label>
              <crm-input-text
                [(value)]="profileRegister.name"
                [isError]="$any(errorProfileRegister?.name)"></crm-input-text>
              <small
                *ngIf="errorProfileRegister?.name"
                class="p-error">
                {{ errorProfileRegister?.name | join }}
              </small>
            </div>
          </ng-container>

          <ng-container *ngIf="activeIndexStep === 2">
            <div class="field">
              <label class="font-medium">Должность</label>
              <crm-input-text
                [(value)]="user.job"
                [isError]="$any(errors?.job)"></crm-input-text>
              <small
                *ngIf="errors?.job"
                class="p-error">
                {{ errors.job | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium required-field">Роли</label>
              <crm-multi-select
                [(selectedItems)]="user.roles"
                [options]="roles"
                [class]="errors?.roles ? 'ng-invalid ng-dirty' : ''"
                [styleClass]="errors?.roles ? 'ng-invalid ng-dirty' : ''"
                itemDescriptionField="type"
                appendTo="body">
              </crm-multi-select>
              <small
                *ngIf="errors?.roles"
                class="p-error">
                {{ errors.roles | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Контрагент</label>
              <crm-contragent-auto-complete
                [(selectedContragent)]="user.contragent"
                [customSearch]="false"
                [showClear]="true"
                [isError]="$any(errors?.contragent)"
                appendTo="body">
              </crm-contragent-auto-complete>
              <small
                *ngIf="errors?.contragent"
                class="p-error">
                {{ errors.contragent | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">График работы</label>
              <crm-single-select
                [(selectedItem)]="user.workSchedule"
                [options]="schedules"
                [class]="errors?.workSchedule ? 'ng-invalid ng-dirty' : ''"
                [styleClass]="errors?.workSchedule ? 'ng-invalid ng-dirty' : ''"
                appendTo="body">
              </crm-single-select>
              <small
                *ngIf="errors?.workSchedule"
                class="p-error">
                {{ errors.workSchedule | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Схема согласования</label>
              <crm-approval-scheme-single-select
                [(selectedApprovalScheme)]="user.approvalScheme"
                [isError]="$any(errors?.approvalScheme)"
                appendTo="body"></crm-approval-scheme-single-select>
              <small
                *ngIf="errors?.approvalScheme"
                class="p-error">
                {{ errors.approvalScheme | join }}
              </small>
            </div>
          </ng-container>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <button
      pButton
      [label]="activeIndexStep === 2 ? 'Добавить' : 'Далее'"
      class="p-button-success mr-2"
      (click)="saveUser()"></button>

    <button
      *ngIf="activeIndexStep"
      pButton
      icon="pi pi-arrow-left"
      label="Назад"
      class="p-button-text p-button-secondary"
      (click)="back()"></button>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
